import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { MaskLines, Reveal } from "./motion";
import { CtaButton } from "./Buttons";

export const CtaBand = ({ onClick, to }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-15%", "15%"]);
  return (
    <section ref={ref} data-testid="cta-band" className="grain relative isolate overflow-hidden bg-[color:var(--ngp-ink)] text-white">
      <motion.img style={{ y, scale: 1.3 }} src="/img/company.webp" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-70" />
      <div className="absolute inset-0 -z-10 bg-[#1d1d1b]/55" />
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-5 py-28 sm:px-8 lg:flex-row lg:items-end lg:justify-between lg:px-12 lg:py-40">
        <h2 className="font-display text-5xl font-semibold uppercase leading-[0.9] tracking-[-0.03em] sm:text-6xl lg:text-8xl">
          <MaskLines onLoad={false} delay={0} lines={["Hai un progetto?", <span className="text-[color:var(--ngp-teal)]">Noi possiamo</span>, "realizzarlo."]} />
        </h2>
        <Reveal delay={0.2} className="shrink-0">
          <CtaButton onClick={onClick} to={to} testId="cta-band-btn">Parlaci del tuo progetto</CtaButton>
        </Reveal>
      </div>
    </section>
  );
};
